<template>
  <dashboard-layout title="Appointments" :kicker="kicker" :items="navItems">
    <partner-assigned-bookings-card :partner-role="partnerRole" standalone-page />
  </dashboard-layout>
</template>

<script>
import DashboardLayout from './DashboardLayout.vue';
import PartnerAssignedBookingsCard from './PartnerAssignedBookingsCard.vue';
import { GROOMER_DASH_NAV, SALON_DASH_NAV } from '@/utils/dashboardNav';

export default {
  name: 'PartnerAppointmentsPage',
  components: { DashboardLayout, PartnerAssignedBookingsCard },
  props: {
    partnerRole: {
      type: String,
      required: true,
      validator: (v) => v === 'groomer' || v === 'salon',
    },
  },
  computed: {
    navItems() {
      return this.partnerRole === 'salon' ? SALON_DASH_NAV : GROOMER_DASH_NAV;
    },
    kicker() {
      return this.partnerRole === 'salon' ? 'Salon dashboard' : 'Groomer dashboard';
    },
  },
};
</script>
